import { Table } from "@/features/Table";
import { type E3Transaction, porfolios_columns } from "./columns";
import {
  type FilterE3TransactionsSchema,
  FilterE3Transactions,
} from "./filter";

const client = "e3";
const table_name = "e3_transactions";

export const E3TransactionsTable = () => {
  return (
    <Table<E3Transaction, FilterE3TransactionsSchema>
      label="Transactions"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterE3Transactions />}
      actions={[
        {
          label: "actions.new",
          route: `e3/${table_name}/new`,
        },
      ]}
    />
  );
};
